<template>
  <div>
    <div class="text-xl font-black py-2">1. Performance Review</div>

    <!-- Sub section -->
    <div class="pt-2">
      <div class="font-black text-lg py-2">Business Forecast</div>
      <div class="flex w-full items-center">
        <div class="flex-1/3">
          <div class="py-2">Business Cascade Calculator</div>
          <panel class="img-div" v-if="form.attachment && form.attachment.business_cascade_calculator_img">
            <img :src="form.attachment.business_cascade_calculator_img" class="w-full pb-2 object-cover bg-gray-100 cursor-pointer" @click="calculatorImgVisible=true" />
            <modal v-if="calculatorImgVisible" @leave="calculatorImgVisible=false" modalClass="max-width-full">
              <img :src="form.attachment.business_cascade_calculator_img" />
            </modal>
          </panel>
          <panel v-else>
            <div>
              <img src="https://via.placeholder.com/400x200.png?text=No+business+cascade+calculator+image">
            </div>
          </panel>
        </div>
      </div>
      <div>Please populate the following fields:</div>
      <div v-for="(question, index) in form.questions[page][sectionStart]" :key="index">
        <hr class="border-b my-8" />
        <review-question-component v-model="form.questions[page][sectionStart][index]" :showMandatory="showMandatory"></review-question-component>
      </div>
    </div>

    <hr class="border-b my-8 border-green-600" />
    <div class="pt-2">
      <div class="flex w-full justify-between">
        <div class="flex-grow py-2"></div>
        <div class="w-1/6 border-l border-r px-4 mr-2 text-center">Previous Year</div>
        <div class="w-1/6 px-4 text-center">This Year</div>
      </div>
      <div v-for="(question2, index2) in form.questions[page][sectionStart+1]" :key="index2">
        <hr class="border-b my-8" />
        <review-question-component v-model="form.questions[page][sectionStart+1][index2]" column-class="w-1/6 flex justify-between" input-class="mb-0" :showMandatory="showMandatory"></review-question-component>
      </div>
    </div>

    <hr class="border-b my-8 border-green-600" />
    <div class="pt-2">
      <div class="font-black text-lg py-2">Overall business discussion:</div>
      <div v-for="(question3, index3) in form.questions[page][sectionStart+2]" :key="index3">
        <review-question-component v-model="form.questions[page][sectionStart+2][index3]" :showMandatory="showMandatory"></review-question-component>
      </div>
    </div>
  </div>
</template>

<script>
import ReviewQuestionComponent from '@/components/AnnualReview/ReviewQuestionComponent'
export default {
  components: { ReviewQuestionComponent },
  props: ['value', 'review', 'page', 'sectionStart', 'showMandatory'],
  data () {
    return {
      form: this.value,
      calculatorImgVisible: false
    }
  },
  mounted () {
  }
}
</script>
